'use es6';

export default {
  _total: 50,
  values: [{
    code: 'ar',
    adWordsId: '1019',
    name: 'Arabic'
  }, {
    code: 'bn',
    adWordsId: '1056',
    name: 'Bengali'
  }, {
    code: 'bg',
    adWordsId: '1020',
    name: 'Bulgarian'
  }, {
    code: 'ca',
    adWordsId: '1038',
    name: 'Catalan'
  }, {
    code: 'zh_CN',
    adWordsId: '1017',
    name: 'Chinese (simplified)'
  }, {
    code: 'zh_TW',
    adWordsId: '1018',
    name: 'Chinese (traditional)'
  }, {
    code: 'hr',
    adWordsId: '1039',
    name: 'Croatian'
  }, {
    code: 'cs',
    adWordsId: '1021',
    name: 'Czech'
  }, {
    code: 'da',
    adWordsId: '1009',
    name: 'Danish'
  }, {
    code: 'nl',
    adWordsId: '1010',
    name: 'Dutch'
  }, {
    code: 'en',
    adWordsId: '1000',
    name: 'English'
  }, {
    code: 'et',
    adWordsId: '1043',
    name: 'Estonian'
  }, {
    code: 'tl',
    adWordsId: '1042',
    name: 'Filipino'
  }, {
    code: 'fi',
    adWordsId: '1011',
    name: 'Finnish'
  }, {
    code: 'fr',
    adWordsId: '1002',
    name: 'French'
  }, {
    code: 'de',
    adWordsId: '1001',
    name: 'German'
  }, {
    code: 'el',
    adWordsId: '1022',
    name: 'Greek'
  }, {
    code: 'gu',
    adWordsId: '1072',
    name: 'Gujarati'
  }, {
    code: 'iw',
    adWordsId: '1027',
    name: 'Hebrew'
  }, {
    code: 'hi',
    adWordsId: '1023',
    name: 'Hindi'
  }, {
    code: 'hu',
    adWordsId: '1024',
    name: 'Hungarian'
  }, {
    code: 'is',
    adWordsId: '1026',
    name: 'Icelandic'
  }, {
    code: 'id',
    adWordsId: '1025',
    name: 'Indonesian'
  }, {
    code: 'it',
    adWordsId: '1004',
    name: 'Italian'
  }, {
    code: 'ja',
    adWordsId: '1005',
    name: 'Japanese'
  }, {
    code: 'kn',
    adWordsId: '1086',
    name: 'Kannada'
  }, {
    code: 'ko',
    adWordsId: '1012',
    name: 'Korean'
  }, {
    code: 'lv',
    adWordsId: '1028',
    name: 'Latvian'
  }, {
    code: 'lt',
    adWordsId: '1029',
    name: 'Lithuanian'
  }, {
    code: 'ms',
    adWordsId: '1102',
    name: 'Malay'
  }, {
    code: 'ml',
    adWordsId: '1098',
    name: 'Malayalam'
  }, {
    code: 'mr',
    adWordsId: '1101',
    name: 'Marathi'
  }, {
    code: 'no',
    adWordsId: '1013',
    name: 'Norwegian'
  }, {
    code: 'fa',
    adWordsId: '1064',
    name: 'Persian'
  }, {
    code: 'pl',
    adWordsId: '1030',
    name: 'Polish'
  }, {
    code: 'pt',
    adWordsId: '1014',
    name: 'Portuguese'
  }, {
    code: 'ro',
    adWordsId: '1032',
    name: 'Romanian'
  }, {
    code: 'ru',
    adWordsId: '1031',
    name: 'Russian'
  }, {
    code: 'sr',
    adWordsId: '1035',
    name: 'Serbian'
  }, {
    code: 'sk',
    adWordsId: '1033',
    name: 'Slovak'
  }, {
    code: 'sl',
    adWordsId: '1034',
    name: 'Slovenian'
  }, {
    code: 'es',
    adWordsId: '1003',
    name: 'Spanish'
  }, {
    code: 'sv',
    adWordsId: '1015',
    name: 'Swedish'
  }, {
    code: 'ta',
    adWordsId: '1130',
    name: 'Tamil'
  }, {
    code: 'te',
    adWordsId: '1131',
    name: 'Telugu'
  }, {
    code: 'th',
    adWordsId: '1044',
    name: 'Thai'
  }, {
    code: 'tr',
    adWordsId: '1037',
    name: 'Turkish'
  }, {
    code: 'uk',
    adWordsId: '1036',
    name: 'Ukrainian'
  }, {
    code: 'ur',
    adWordsId: '1041',
    name: 'Urdu'
  }, {
    code: 'vi',
    adWordsId: '1040',
    name: 'Vietnamese'
  }]
};